// extracted by mini-css-extract-plugin
export default {"app-download":"user_app-download__HvmMr","app-instructions":"user_app-instructions__QiboN","appstore-button":"user_appstore-button__1cWYK"};